export const shopConstants = {
    TOP_PICKS_REQUEST: "TOP_PICKS_REQUEST",
    TOP_PICKS_COMPLETE: "TOP_PICKS_COMPLETE",

    TRENDINGS_REQUEST: "TRENDINGS_REQUEST",
    TRENDINGS_COMPLETE: "TRENDINGS_COMPLETE",

    FAVOURITES_REQUEST: "FAVOURITES_REQUEST",
    FAVOURITES_COMPLETE: "FAVOURITES_COMPLETE",

    VOUCHER_DETAILS_REQUEST: "VOUCHER_DETAILS_REQUEST",
    VOUCHER_DETAILS_COMPLETE: "VOUCHER_DETAILS_COMPLETE",

    SET_VOUCHER_BY_VALUES: "SET_VOUCHER_BY_VALUES",

    CONFIRM_ORDER_REQUEST: "CONFIRM_ORDER_REQUEST",
    CONFIRM_ORDER_COMPLETE: "CONFIRM_ORDER_COMPLETE",

    ORDER_DETAILS_REQUEST: "ORDER_DETAILS_REQUEST",
    ORDER_DETAILS_COMPLETE: "ORDER_DETAILS_COMPLETE",

    VOUCHER_WALLET_REQUEST: "VOUCHER_WALLET_REQUEST",
    VOUCHER_WALLET_COMPLETE: "VOUCHER_WALLET_COMPLETE",

    BROWSE_PRODUCTS_REQUEST: "BROWSE_PRODUCTS_REQUEST",
    BROWSE_PRODUCTS_COMPLETE: "BROWSE_PRODUCTS_COMPLETE",

    BROWSE_PRODUCTS_POPULAR_FILTER_REQUEST:
        "BROWSE_PRODUCTS_POPULAR_FILTER_REQUEST",
    BROWSE_PRODUCTS_POPULAR_FILTER_COMPLETE:
        "BROWSE_PRODUCTS_POPULAR_FILTER_COMPLETE",

    BROWSE_PRODUCTS_CATEGORY_REQUEST: "BROWSE_PRODUCTS_CATEGORY_REQUEST",
    BROWSE_PRODUCTS_CATEGORY_COMPLETE: "BROWSE_PRODUCTS_CATEGORY_COMPLETE",

    BUY_POINTS_REQUEST: "BUY_POINTS_REQUEST",
    BUY_POINTS_COMPLETE: "BUY_POINTS_COMPLETE",

    REDEEM_VOUCHER_REQUEST: "REDEEM_VOUCHER_REQUEST",
    REDEEM_VOUCHER_COMPLETE: "REDEEM_VOUCHER_COMPLETE",

    RATE_VOUCHER_REQUEST: "RATE_VOUCHER_REQUEST",
    RATE_VOUCHER_COMPLETE: "RATE_VOUCHER_COMPLETE",

    SHOP_TLC_GET_POINT_BALANCE_REQUEST:'SHOP_TLC_GET_POINT_BALANCE_REQUEST',
    SHOP_TLC_GET_POINT_BALANCE_COMPLETE:'SHOP_TLC_GET_POINT_BALANCE_COMPLETE',

    SHOP_TLC_REBAT_POINTS_REQUEST:'SHOP_TLC_REBAT_POINTS_REQUEST',
    SHOP_TLC_REBAT_POINTS_COMPLETE:'SHOP_TLC_REBAT_POINTS_COMPLETE',

    SHOP_TLC_CLEAR_POINTS:'SHOP_TLC_CLEAR_POINTS'
};

export const orderStatus = {
    OERDERED: 1,
    FAILED: 2,
    COMPLETED: 3,
    EXPIRED: 4,
};

export const StripePaymentNextStep = {
    NONE: 0,
    REDIRECT: 1,
    HANDLECARDACTION: 2,
};

export const voucherCategoryTypes = {
    BLACK_HAWK_VOUCHER: 1,
    CUSTOM_REWARD_VOUCHER: 2,
    EXPERIENCE_VOUCHER: 3,
};

export const addRemoveFavouriteContent = {
    FROM_HOME_PAGE: "FROM_HOME_PAGE",
    FROM_PRODUCT_CONTENT: "FROMT_PRODUCT_CONTENT",
    FROM_WALLET: "FROM_WALLET",
};
